import {takeLatest} from 'redux-saga/effects';
import * as constants from './constants';
import * as saga from './saga';

export default function*() {
    yield takeLatest(constants.GET_TRANSACTION_DETAIL.REQUEST, saga.getTransactionDetail);
    yield takeLatest(constants.GET_TRANSACTION_DETAIL.SUCCESS, saga.getTransactionDetailSuccess);
    yield takeLatest(constants.GET_TRANSACTION_DETAIL.FAILED, saga.getTransactionDetailFailed);
}
